import axios from 'axios';

// Configure axios defaults
const apiUrl = import.meta.env.VITE_API_URL || '';
if (apiUrl) {
  axios.defaults.baseURL = apiUrl;
}

// Request interceptor to add token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      delete axios.defaults.headers.common['Authorization'];
      
      // Redirect to login if not already on public page
      const currentPath = window.location.pathname;
      if (!['/', '/student', '/contact'].includes(currentPath)) {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default axios;